/**
 * @module queryStringToObject
 * @description Convert query string structure to a Javascript object
 * @since 1.4.0
 */

import { breakPair } from '../__breakPair';

/**
 * Convert a query string to an object.
 * @param  {String} string Complete query string (w/o the mod, i.e. "?")
 * @return {Object}
 *
 * @example
 * queryStringToObject('param1=value1&param2=value2') // {param1: 'value1', param2: 'value2'}
 */
export const queryStringToObject = (string = '') => Object.assign(...string.split('&').map(breakPair));
